/** Keyboard shortcuts (↑/↓ in a list, "/" for search) stay out of the way while the rep types (D65). */
const NOT_TEXT = new Set(['checkbox', 'radio', 'button', 'submit', 'reset', 'range', 'color', 'file']);

export const isTyping = (target: EventTarget | null): boolean => {
  if (!(target instanceof HTMLElement)) return false;
  if (target.isContentEditable || target.tagName === 'TEXTAREA' || target.tagName === 'SELECT') return true;
  return target instanceof HTMLInputElement && !NOT_TEXT.has(target.type);
};

/** The same, for an event heard on the document: a field inside a shadow root (the Places search on
 *  Route) reaches the document as its host element, so the event's own origin is checked, and a
 *  focused element that hosts a shadow root counts as a field. */
export const isTypingEvent = (e: Event): boolean => {
  if (isTyping(e.composedPath()[0] ?? null) || isTyping(e.target)) return true;
  const active = document.activeElement;
  return active instanceof HTMLElement && active.tagName.includes('-') && active.shadowRoot !== null;
};
